<template>
  <div class="copy-object-instruction">
    <h3>{{ $t("copy_object_instruction_title") }}</h3>
    <ul>
      <li
        v-for="(item, index) in copyInstruction"
        :key="index"
        v-html="item"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CopyObjectInstruction",
  data() {
    return {};
  },
  computed: {
    copyInstruction() {
      return [
        this.$t("copy_object_instruction_1"),
        this.$t("copy_object_instruction_2"),
        this.$t("copy_object_instruction_3"),
        this.$t("copy_object_instruction_4"),
        this.$t("copy_object_instruction_5")
      ];
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.copy-object-instruction {
  margin: 10px 15px;
  font-size: $main_font_size;
  text-align: justify;

  ul {
    margin-left: 40px;
  }

  h4 {
    padding-top: $element_padding_on_top;
  }
}
</style>
